var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-copyright-model"},[_c('p',[_vm._v("Copyright © 2025 广州市济帆生物科技有限公司 版权所有 粤网药信备字(2025)第00042号")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/copyright.vue